<script setup>
// FAQs with nothing to show (phase 4.2, D-G5). Approved: the kit's Empty over faded kit ResponseCards with neutral
// examples (POLARIS.PAGES.EXAMPLES). Pending: the Empty alone ("nothing to review"), with "clear filters" when a
// search is on. The invitation that used to sit here (FeatureSpotlight) is now the page's Invitation (PageLayout).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import ResponseCard from 'dashboard/components-next/polaris/cards/ResponseCard.vue';
import PolarisEmptyState from './PolarisEmptyState.vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'approved',
    validator: value => ['approved', 'pending'].includes(value),
  },
  hasActiveFilters: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click', 'clearFilters']);

const { t, tm, rt } = useI18n();

const isApproved = computed(() => props.variant === 'approved');
const examples = computed(() =>
  tm('POLARIS.PAGES.EXAMPLES.RESPONSES').map(example => ({
    question: rt(example.QUESTION),
    answer: rt(example.ANSWER),
    source: rt(example.SOURCE),
  }))
);
</script>

<template>
  <PolarisEmptyState
    v-if="isApproved"
    :title="t('POLARIS.RESPONSES.EMPTY_STATE.TITLE')"
    :description="t('POLARIS.RESPONSES.EMPTY_STATE.SUBTITLE')"
    :action-label="t('POLARIS.RESPONSES.ADD_NEW')"
    :action-perms="['administrator']"
    @click="emit('click')"
  >
    <template #backdrop>
      <ResponseCard
        v-for="example in examples"
        :key="example.question"
        v-bind="example"
      />
    </template>
  </PolarisEmptyState>
  <PolarisEmptyState
    v-else
    :title="t('POLARIS.RESPONSES.EMPTY_STATE.NO_PENDING_TITLE')"
  >
    <Button
      v-if="hasActiveFilters"
      variant="link"
      size="sm"
      @click="emit('clearFilters')"
    >
      {{ t('POLARIS.RESPONSES.EMPTY_STATE.CLEAR_SEARCH') }}
    </Button>
  </PolarisEmptyState>
</template>
